namespace $ {

	export class $shm_hitalama_map_project_maps extends $giper_baza_list_link.to(
		()=> $shm_hitalama_map,
	) {}

	export class $shm_hitalama_map_project_maps_link extends $giper_baza_atom_link.to(
		()=> $shm_hitalama_map_project_maps,
	) {}

	export class $shm_hitalama_map_project extends $giper_baza_entity.with({
		Maps: $shm_hitalama_map_project_maps_link,
		Created_at: $giper_baza_atom_real,
		Changed_at: $giper_baza_atom_real,
		Version: $giper_baza_atom_real,
	}) {

		@ $mol_action
		static make_new( title: string ) {
			const land = this.$.$giper_baza_glob.land_grab([[ null, $giper_baza_rank_deny ]])
			const project = land.Data( $shm_hitalama_map_project )
			const now = ( new $mol_time_moment ).valueOf()
			project.title( title )
			project.Created_at( null )?.val( now )
			project.Changed_at( null )?.val( now )
			project.Version( null )?.val( 1 )
			return project
		}

		Maps_list( auto?: null ) {
			const unit = this.find( 'Maps' )
			if( unit && unit.tag() !== $giper_baza_atom_link.tag ) {
				throw new Error( 'Не удалось открыть список карт проекта' )
			}
			let slot = this.Maps()
			if( !slot && unit ) {
				throw new Error( 'Не удалось открыть список карт проекта' )
			}
			slot ??= this.Maps( auto )
			const list = slot?.remote() ?? slot?.ensure( this.land() )
			if( list && typeof ( list as any ).remote_list === 'function' ) return list

			throw new Error( 'Не удалось открыть список карт проекта' )
		}

	}

	export class $shm_hitalama_map_project_list extends $giper_baza_list_link.to(
		()=> $shm_hitalama_map_project,
	) {}

	export class $shm_hitalama_map_project_list_link extends $giper_baza_atom_link.to(
		()=> $shm_hitalama_map_project_list,
	) {}

}
